import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { HttpClientModule } from '@angular/common/http';
import { MinkaLoginComponent } from './minka-login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MinkaLoginService } from './minka-login.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MinkaNotificacionComponent } from './minka-notificacion/minka-notificacion.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RecuperarclaveComponent } from './recuperarclave/recuperarclave.component';

export const translateModule = TranslateModule.forRoot();

const routes = [
  {
      path     : 'login',
      component: MinkaLoginComponent
  },
  {
      path     : 'forgot-password',
      component: RecuperarclaveComponent,
  }
];
export const rutas = RouterModule.forRoot(routes);
@NgModule({
  declarations: [MinkaLoginComponent, MinkaNotificacionComponent,RecuperarclaveComponent],
  imports: [
    rutas,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    FormsModule,
    MatDialogModule,
 
    translateModule,
    MatMenuModule,
    MatToolbarModule,
   
  ],
  exports: [ 

    MinkaLoginComponent, 
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    FormsModule,
    MatDialogModule,
    TranslateModule,
    MatMenuModule,
    MatToolbarModule,
  
  ],
  providers : [
    MinkaLoginService,

  ]
})
export class MinkaLoginModule { }
